// именительный | родительный | предложный
type TDeclensionType = 'nominative_case' | 'genitive_case' | 'prepositional_case';

export const getDistrictDeclination = (word: string, declensionType: TDeclensionType, full = true) => {
  const lastLetter = word.slice(-1);
  const isLastLetterSkip = lastLetter === 'о' || lastLetter === 'а' || lastLetter === 'и' || lastLetter === 'е';
  switch (declensionType) {
    case 'nominative_case':
      switch (lastLetter) {
        case 'о':
        case 'а':
        case 'и':
        case 'е':
          return full ? 'район ' + word : word;
        case 'к':
          return full ? word + 'ий район' : word + 'ий';
        default:
          return full ? word + 'ый район' : word + 'ый';
      }
    case 'genitive_case':
      return isLastLetterSkip ? 'района ' + word : word + 'ого района';
    case 'prepositional_case':
      return isLastLetterSkip ? (full ? 'районе ' + word : word) : word + 'ом районе';
  }
};
